import React, { useEffect, useState } from 'react'
// import QRCode from "react-qr-code";
import { v4 as uuidv4 } from 'uuid';
import Barcode from "react-barcode";
// import SearchIcon from '@mui/icons-material/Search';
import ScienceIcon from '@mui/icons-material/Science';
import axios from 'axios';
// import Modal from 'react-bootstrap/Modal';
import { usePapaParse } from 'react-papaparse';
import { useCSVDownloader } from 'react-papaparse';
import Modal from 'react-bootstrap/Modal';
import { Progress } from 'react-sweet-progress';
import "react-sweet-progress/lib/style.css";
import Spinner from 'react-bootstrap/Spinner';
import toImg from 'react-svg-to-image';
function OnPrinting({ serverUrl, user, titleOfPage, globalUserId, globalToken }) {
    const { jsonToCSV } = usePapaParse();
    const { CSVDownloader, Type } = useCSVDownloader();



    // const [newBarCodeView, setNewBarCodeView] = useState(false);
    const [checkedAll, setCheckedAll] = useState(false);
    const [recordsData, setRecordsData] = useState([]);
    const [currentData, setCurrentsData] = useState([]);
    const [allLabs, setAllLabs] = useState([]);

    const [validity, setValidity] = useState("10");
    const [barcodeNumber, setBarcodeNumber] = useState("");

    const [selectedBox, setSelectedBox] = useState([]);

    const [yearFilter, setYearFilter] = useState("all")
    const [labFilter, setLabFilter] = useState("all")

    const [labCodeToAssign, setLabCodeToAssign] = useState("")

    const [showProgress, setShowProgress] = useState(false)
    const [progressOutOf, setProgressOutOf] = useState("")
    const [progressPercentage, setProgressPercentage] = useState(0)
    const [progressStatus, setProgressStatus] = useState("active")

    const [showLabAssign, setShowLabAssign] = useState(false)
    const [barcodesLoading, setBarcodesLoading] = useState(true)

    const [quantityToAssign, setQuantityToAssign] = useState();

    const handleSelectAll = () => {
        const allButtons = document.querySelectorAll(".barCodeSelector");
        if (checkedAll) {
            for (let i = 0; i < allButtons.length; i++) {
                allButtons[i].checked = false
            }
            setCheckedAll(false)
            setSelectedBox([])

            // console.log(selectedBox)
        } else {
            let allRest = [];
            for (let i = 0; i < allButtons.length; i++) {
                allButtons[i].checked = true
                allRest.push(allButtons[i].id)
            }

            setSelectedBox(allRest)
            setCheckedAll(true)

            // console.log(allRest)
        }
    }


    const getAllBarcodes = async () => {
        const query = { code: "all" }

        const getData = await axios.post(serverUrl + "/barcodes/find", query)
        if (getData.status == 200) {
            // console.log(getData.data)
            setRecordsData(getData.data)
            setCurrentsData(getData.data)
            setBarcodesLoading(false)
        } else {
            setBarcodesLoading(false)
            console.log(getData.data)
        }
    }

    const resetAllFields = () => {
        setRecordsData([]);
        setValidity("");
        setBarcodeNumber("");
        setSelectedBox([])
    }

    const updateSelectedValues = (code) => {
        let allRest = selectedBox;

        if (allRest.includes(code)) {
            allRest = allRest.filter((oldcode) => { return oldcode !== code })
            // console.log(allRest)
        } else {
            allRest.push(code)
            // console.log(allRest)
        }
        setSelectedBox(allRest);
    }


    const markStateAs = async (e, As) => {
        e.preventDefault()
        setShowLabAssign(false)
        // console.log(labCodeToAssign)

        let resultsToShow = [];

        setShowProgress(true)

        for (let i = 0; i < selectedBox.length; i++) {
            setProgressOutOf(`${i + 1} / ${selectedBox.length}`)
            setProgressPercentage(Math.floor((i + 1) / selectedBox.length * 100))

            const query = { "selectedCode": selectedBox[i], "markAs": As, "usedTo": labCodeToAssign }

            const markNow = await axios.post(serverUrl + "/barcodes/markStatusAs", query)

            if (markNow.status !== 200) {
                setProgressStatus("error")
                console.log(markNow.data)
            } else {
                resultsToShow.push(query)
            }
        }
        setProgressStatus("success")
        updateLog({ "Name": "Barcode Status Changed", "Codes": selectedBox, "Details": resultsToShow })
        getAllBarcodes()
    }

    const assignStocksToLab = async (e) => {
        e.preventDefault()

        const query = {
            "stocks": quantityToAssign,
            "lab": labCodeToAssign
        }
        console.log(query)
        const assignNow = await axios.post(serverUrl + "/labs/assignStocks", query);

        if (assignNow.status == 200) {
            alert(assignNow.data)
            console.log(assignNow.data)
        } else {
            alert(assignNow.data)
            console.log(assignNow.data)
        }
    }


    const updateLog = async (data) => {
        const dataSet = {
            "userId": user.userId,
            "changes": data,
        }
        const updateNow = await axios.post(serverUrl + "/users/updateLog", dataSet)
        if (updateNow.status == 200) {
            // console.log(updateNow.data)
        } else {
            console.log(updateNow.data)
        }
    }

    const getAllLabs = async () => {
        const getAllLabs = await axios.post(serverUrl + "/labs/get", { code: "all" });
        if (getAllLabs.status == 200) {
            setLabCodeToAssign(getAllLabs.data[0].code)
            setAllLabs(getAllLabs.data);
        } else {
            console.log("No Data Found");
        }
    }

    useEffect(() => {
        setSelectedBox([])
        getAllBarcodes()
        getAllLabs()



        toImg(
            // <Barcode
            //     value={"G657D6776576"}
            //     width={2}
            //     height={60}
            //     format="CODE39"
            //     displayValue={true}
            //     fontOptions=""
            //     font="monospace"
            //     // textAlign="center"
            //     textPosition="bottom"
            //     // textMargin={2}
            //     fontSize={35}
            //     background="#ffffff"
            //     lineColor="#000000"
            //     // margin={10}
            //     // marginTop=""
            //     // marginBottom=""
            //     // marginLeft=""
            //     // marginRight=""
            //     id=""

            // />
            "svg"
            , 'name',
            {
                scale: 3,
                format: 'webp',
                quality: 0.01,
                download: false,
                ignore: '.ignored'
            }
        ).then(fileData => {
            console.log(fileData)
        });


    }, [])


    return (
        <>
            <div className='h-100 w-100 dataTableSet d-flex flex-column overflow-auto'>
                <div className='w-100 upperMoonsSearchBackground themeTextColor border-0 fs-4 p-0 shadow-sm text-center'>{titleOfPage}</div>
                <div className='p-2 p-md-3 p-lg-3 overflow-auto d-flex flex-column rounded-0 h-100'>
                    <div className='mb-3 d-flex gap-3 justify-content-between  flex-wrap'>
                        <div className='d-flex gap-5 flex-wrap'>
                            <div className='d-flex gap-2 align-items-center upperMoonsSearch'>
                                <span className='fw-bold'>
                                    <ScienceIcon style={{ width: "1.7em", height: "1.7em" }} />
                                </span>
                                <select name="" id="" className='customFieldForDence' onChange={(e) => { if (e.target.value != "all") { setCurrentsData(recordsData.filter((product) => { return product.name?.includes(e.target.value) })) } else { setCurrentsData(recordsData) } }}>
                                    <option value="all">All</option>
                                    {
                                        allLabs.map((data, key) => {
                                            return <option key={key} value={data.name}>{data.name}</option>
                                        })
                                    }
                                </select>
                            </div>
                            <button className="btn btn-secondary px-4 py-2 rounded-pill fw-bold" onClick={(e) => { setShowLabAssign(true); }}>Assign To Lab</button>
                        </div>
                        <div className='d-flex gap-5 flex-wrap'>
                            <div className='d-flex gap-2 align-items-center upperMoonsSearch'>
                                <span className='fw-bold'>
                                    <ScienceIcon style={{ width: "1.7em", height: "1.7em" }} />
                                </span>
                                <select name="" id="" className='customFieldForDence' onChange={(e) => { if (e.target.value != "all") { setYearFilter(e.target.value) } else { setYearFilter("all") } }}>
                                    <option value="all">All</option>
                                    <option value="10">10 Years</option>
                                    <option value="12">12 Years</option>
                                    <option value="15">15 Years</option>
                                    <option value="20">20 Years</option>
                                </select>
                            </div>
                            <CSVDownloader
                                type={Type.Button}
                                filename={'OnPrinting'}
                                bom={true}
                                config={{
                                    delimiter: ',',
                                }}
                                className="btn btn-success px-4 py-2 rounded-pill fw-bold"
                                data={
                                    jsonToCSV(currentData.filter((data) => { return data.status === "Market_Printing_Out" && (data.validityYear?.toString().includes(yearFilter) || yearFilter == "all") }))
                                }
                            >
                                Export to Excel
                            </CSVDownloader>
                        </div>
                    </div>
                    <div className="themeTextColor fs-5 my-3 fw-bold d-flex gap-1">
                        <span>
                            Total Records:
                        </span>
                        {
                            currentData.length > 0 ?
                                currentData.filter((data) => { return data.status === "Market_Printing_Out" && (data.validityYear?.toString().includes(yearFilter) || yearFilter == "all") }).length > 0 ?
                                    currentData.filter((data) => { return data.status === "Market_Printing_Out" && (data.validityYear?.toString().includes(yearFilter) || yearFilter == "all") }).length
                                    :
                                    "0"
                                :
                                "0"
                        }
                    </div>
                    <div className='overflow-auto'>
                        <table className='table table-light table-bordered w-100 table-striped pb-5 text-center m-0'>
                            <thead className=''>
                                <tr align="center" className='sticky-top'>
                                    <th valign='middle'><input type="checkbox" className='form-check-input' onChange={(e) => { handleSelectAll(); }} /></th>
                                    <th valign='middle' width="1%"><span className='text-nowrap'>Barcode Image</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Barcode No.</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Generated Date</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Validity Year</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Status</span></th>
                                </tr>
                            </thead>
                            {
                                !barcodesLoading ?
                                    <tbody>
                                        {
                                            currentData.length > 0 ?
                                                currentData.filter((data) => { return data.status === "Market_Printing_Out" && (data.validityYear?.toString().includes(yearFilter) || yearFilter == "all") }).length > 0 ?
                                                    currentData.filter((data) => { return data.status === "Market_Printing_Out" && (data.validityYear?.toString().includes(yearFilter) || yearFilter == "all") }).map((data, key) => {
                                                        return (
                                                            <tr key={key}>
                                                                <td valign='middle'>
                                                                    <input type="checkbox" id={data.code} className='form-check-input barCodeSelector' onChange={(e) => { updateSelectedValues(data.code) }} />
                                                                </td>
                                                                <td valign='middle'>
                                                                    <Barcode
                                                                        value={data.code}
                                                                        width={2}
                                                                        height={60}
                                                                        format="CODE39"
                                                                        displayValue={true}
                                                                        fontOptions=""
                                                                        font="monospace"
                                                                        // textAlign="center"
                                                                        textPosition="bottom"
                                                                        // textMargin={2}
                                                                        fontSize={35}
                                                                        background="#ffffff"
                                                                        lineColor="#000000"
                                                                        // margin={10}
                                                                        // marginTop=""
                                                                        // marginBottom=""
                                                                        // marginLeft=""
                                                                        // marginRight=""
                                                                        id=""
                                                                        className="barcodeImages"

                                                                    />
                                                                    {/* <QRCode
                                                                size={256}
                                                                // bgColor=""
                                                                fgColor="#D87339"
                                                                level="M"
                                                                title={uuidv4()}
                                                                style={{ height: "auto", maxWidth: "60px", width: "100%" }}
                                                                value={uuidv4()}
                                                                viewBox={`0 0 256 256`}
                                                            /> */}
                                                                </td>
                                                                <td valign='middle'>{data.code}</td>
                                                                <td valign='middle'>
                                                                    {data.generatedDate}
                                                                </td>
                                                                <td valign='middle'>{data.validityYear}</td>
                                                                <td valign='middle'>{data.status}</td>
                                                            </tr>
                                                        )
                                                    })
                                                    :
                                                    <tr>
                                                        <td valign='middle' colSpan={6}>
                                                            <div className="upperMoonsSearchBackground p-2 themeTextColor fw-bold">
                                                                No Data
                                                            </div>
                                                        </td>
                                                    </tr>
                                                :
                                                <tr>
                                                    <td valign='middle' colSpan={6}>
                                                        <div className="upperMoonsSearchBackground p-2 themeTextColor fw-bold">
                                                            No Data
                                                        </div>
                                                    </td>
                                                </tr>
                                        }

                                    </tbody>
                                    :
                                    <tbody>
                                        <tr>
                                            <td valign='middle' colSpan={6}>
                                                <div className="upperMoonsSearchBackground p-2 themeTextColor fw-bold">
                                                    <Spinner animation="border" variant="dark" size="lg" />
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                            }
                        </table>
                    </div>
                </div>
            </div>


            {/* Assign To Lab */}
            <Modal
                show={showLabAssign}
                onHide={() => {
                    setShowLabAssign(false);
                }}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <form action="" onSubmit={(e) => { assignStocksToLab(e) }}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <span className='themeTextColor'>
                                Lab Assignment
                            </span>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className='d-flex justify-content-center w-100'>
                            <div className='d-flex flex-column justify-content-start align-items-start gap-3'>
                                <span className='d-flex flex-column w-100'>
                                    <span className='themeTextColor fs-6'>Quantity to Assign</span>
                                    <input type="number" placeholder='Quantity' className='customFieldForDence w-100' min={0} value={quantityToAssign} onInput={(e) => { setQuantityToAssign(e.target.value); }} />
                                </span>
                                <span className='d-flex flex-column'>
                                    <span className='themeTextColor fs-6'>Chose a Lab to Assign Selected Cards</span>
                                    <select className='customFieldForDence w-100' required onInput={(e) => { setLabCodeToAssign(e.target.value); }}>
                                        {
                                            allLabs.map((data, key) => {
                                                return <option key={key} value={data.code}>{data.name}</option>
                                            })
                                        }
                                    </select>
                                </span>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className='w-100 d-flex justify-content-center'>
                            <button type='submit' className='themeButtons rounded-pill text-light w-100 px-4 py-1 fs-6' style={{ maxWidth: "200px" }}>Assign Now</button>
                        </div>
                    </Modal.Footer>
                </form>
            </Modal>

            {/* Progress Bars */}
            <Modal
                show={showProgress}
                onHide={() => {
                    setShowProgress(false);
                    setProgressOutOf("")
                    setProgressPercentage(0)
                    setProgressStatus("active")
                }}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <span className='themeTextColor'>
                            Generating the Barcode
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col d-flex justify-content-center flex-column align-items-center">
                                <Progress
                                    type="circle"
                                    percent={progressPercentage}
                                    status={progressStatus}
                                    strokeWidth={4}
                                    width={150}
                                    style={{}}
                                    theme={{
                                        success: {
                                            symbol: '',
                                            color: 'limegreen'
                                        },
                                        active: {
                                            symbol: '',
                                            color: 'skyblue'
                                        },
                                        error: {
                                            symbol: '',
                                            color: 'red'
                                        },
                                        default: {
                                            symbol: '',
                                            color: '#fbc630'
                                        }
                                    }} />
                                <span className='themeTextColor fs-3'>
                                    {progressOutOf}
                                </span>
                            </div>
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <div className='w-100 d-flex justify-content-center'>
                        {
                            progressStatus == "success" ?
                                <button className='themeButtons w-100 px-5 py-1 rounded-pill fs-5' style={{ maxWidth: "200px" }} onClick={() => { setShowProgress(false) }}>Done</button>
                                :
                                <button className='themeButtons w-100 px-5 py-1 rounded-pill fs-5' disabled style={{ maxWidth: "200px" }}>
                                    <Spinner animation="grow" variant="light" size="sm" />
                                    <Spinner animation="grow" variant="light" size="sm" />
                                    <Spinner animation="grow" variant="light" size="sm" />
                                </button>
                        }
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default OnPrinting